import { values } from 'lodash/fp'

export type Params = { [key in string]: string | undefined | null }

export const getParams = (params?: Params) =>
  params && values(params).length
    ? '?' + new URLSearchParams(params as Record<string, string>).toString()
    : ''
